export enum EExportType {
    SaisieMinVCEE = 1,
    SaisieMinVCEEGrouped,
    SoutienBioMinVCE,
    SoutienBioDiat,
    OSUR,
    EchangeListe,
    StandardLac,
    SaisieMphytCE,
    RE,

    RI,

    RP
}